import { ChatMockApi } from './chat/api';
import { DashboardMockApi } from './dashboard/api';
import { CountryMockApi } from './mdm/country/api';
export const mockApiServices = [CountryMockApi, ChatMockApi, DashboardMockApi];
